<template lang="pug">
bottom-modal#station-list-popup(width='w-xtra-large', :loading='loading', @modal-hidden="onModalHidden")
    span.text-capitalize(slot="header-text") {{ title }}
    div(slot="body")
        .container
          .row
            .col-md-3
              filter-sidebar(ref="filterSidebar", :updateFilters="updateFilters", :onAddAllChange="setAddAllMatch")

            .col-md-9
              .alert.alert-info
                v-loading(loader="fetch-stations-count")
                  template(v-if="stationsPoolCount > 0")
                    | {{ stationsPoolCount }} stations match the filters
                  template(v-else)
                    | No stations under the applied filters

              .alert.alert-warning
                template(v-if="stationsToAddCount > 0")
                  | {{ stationsToAddCount }} stations selected
                template(v-else-if="isDealerMode")
                  | All your stations selected
                template(v-else)
                  | All stations selected

              v-server-table(
                :url="stationsUrl",
                :columns="columns",
                :options="tableOptions",
                :name="tableName",
                ref="datatable"
              )
                template(slot="select", slot-scope="props")
                  label.md-check
                    input(
                      :disabled="addAllMatching || !canEditPromotion"
                      type="checkbox",
                      :checked="props.row.selected",
                      v-model="promotion.outlets",
                      :value="props.row.id")
                    i.indigo

    button.btn.btn-fw.primary(
      slot="footer",
      v-if="canEditPromotion"
      @click="apply_station",
      :disabled="onLoading(outletLoading)")
      v-loading(:loader="outletLoading") Save

</template>

<script>
import reject from 'lodash/reject';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import FilterSidebar from './templates/filter-sidebar';
import PermissionMixin from './mixin/promotion-permissions';

export default {
    components: {
        FilterSidebar,
    },

    mixins: [PermissionMixin],

    props: {
        promotion: {
            type: Object,
            required: true,
        },

        outletList: {
            type: Array,
            required: true,
        },

        title: {
            type: String,
            required: false,
            default: 'Select stations',
        },
    },

    data() {
        let outletsText = this.trans('general.outlets').toLowerCase();

        return {
            ajaxTagLoading: false,
            outletLoading: false,
            addAllMatching: false,
            stations: [],
            outletsText,
            outletsMapped: false,
            filters: {
                regions: [],
                zones: [],
                trading_area: [],
                search: null,
            },
            tableName: 'STATION_LIST_POOL',
            columns: ['select', 'code', 'name'],
        };
    },

    computed: {
        ...mapGetters('promotion', ['stationsPoolCount', 'stationsPool']),

        selectedOutlets() {
            return this.promotion.outlets;
        },

        modalId() {
            return 'station-list-popup';
        },

        loading() {
            return this.onLoading('fetch-station-list');
        },

        stationsUrl() {
            return Laroute.route('franchise.outlet.index');
        },

        tableOptions() {
            return {
                sortable: [],
                filterable: false,
                params: {
                    region_ids: this.filters.regions.map(t => t.id),
                    query: this.filters.search,
                    zone_ids: this.filters.zones.map(t => t.id),
                    trading_area_ids: this.filters.trading_area.map(t => t.id),
                    update_only: this.updateMode,
                },
                headings: {
                    select: (h, row) => {
                        return require('./heading-select-station').call(
                            this,
                            h,
                            row,
                        );
                    },
                    code: 'Site Id',
                    name: 'Name',
                },
            };
        },

        stationsToAddCount() {
            return this.addAllMatching
                ? this.stationsPoolCount
                : this.promotion.outlets.length;
        },
    },

    watch: {
        selectedOutlets() {
            if (!this.outletsMapped) {
                this.mapOutletIds();
                this.outletsMapped = true;
            }
        },
    },

    created() {
        this.$on('show-station-list', updateMode => {
            this.reset(updateMode);
            this.refreshStationsCount();
        });
    },

    mounted() {
        var that = this;
        this.refreshOutletList(null);

        $('#station-popup').on('hidden.bs.modal', function(e) {
            that.errors.clear();
            this.addAllMatching = false;
        });

        this.stationShow();
    },

    methods: {
        ...mapActions('outlet', ['findOutlets', 'getOutletListIfNecessary']),
        ...mapActions('promotion', ['getStationsCount', 'getStations']),
        ...mapMutations('promotion', ['setSelectedAll']),

        stationShow() {
            this.$on('show-station-list', id => {
                this.showModal();
            });
        },

        showModal() {
            $('#station-list-popup').modal('show');
        },

        hideModal() {
            $('#station-list-popup').modal('hide');
        },

        onSelect(items) {
            this.stations = items;
        },

        apply_station() {
            try {
                if (this.addAllMatching) {
                    let params = {
                        filters: {
                            region_ids: this.filters.regions.map(t => t.id),
                            query: this.filters.search,
                            zone_ids: this.filters.zones.map(t => t.id),
                            trading_area_ids: this.filters.trading_area.map(
                                t => t.id,
                            ),
                        },
                    };

                    this.getStations(params);

                    this.promotion.outlets = this.stationsPool.map(t => t.id);
                }

                this.hideModal();
                this.$emit('updateStation', this.promotion);
            } catch (e) {
                this.showApiError(e);
            }
        },

        async mapOutletIds() {
            if (_.isNil(this.promotion.outlets)) {
                return;
            }

            if (this.promotion.outlets.length === 0) {
                return;
            }

            let ol = await this.findOutlets({ ids: this.promotion.outlets });

            this.stations = this.promotion.outlets.map(id =>
                ol.find(o => o.id === id),
            );
        },

        refreshOutletList: _.debounce(function(query) {
            this.getOutletListIfNecessary({ query: query });
        }, 500),

        reset(updateMode) {
            this.updateMode = updateMode;
            this.selectedProducts = [];
            this.filters.zone = [];
            this.filters.trading_area = [];
            this.filters.region = [];
            this.filters.search = null;
        },

        refreshStations() {
            this.$refs.datatable.refresh();
        },

        updateFilters(filters) {
            this.filters = filters;
            this.refreshFilters();
        },

        refreshFilters() {
            // Workaround because the params doesn't seems to be
            // updated when changed within the same event bus
            this.$nextTick(this.refreshStations);
            this.refreshStationsCount();
        },

        refreshStationsCount() {
            let params = {
                filters: {
                    region_ids: this.filters.regions.map(t => t.id),
                    query: this.filters.search,
                    zone_ids: this.filters.zones.map(t => t.id),
                    trading_area_ids: this.filters.trading_area.map(t => t.id),
                    update_only: this.updateMode,
                },
            };

            this.getStationsCount(params);
        },

        onModalHidden() {
            this.$refs.filterSidebar.resetFilters();
            this.filters = {
                regions: [],
                zones: [],
                trading_area: [],
                search: null,
            };
            this.addAllMatching = false;
        },

        setAddAllMatch(addAll) {
            this.addAllMatching = addAll;
        },

        async onChangeSelectAll(value) {
            if (value == true) {
                this.setSelectedAll(true);
                let params = {
                    filters: {
                        region_ids: this.filters.regions.map(t => t.id),
                        query: this.filters.search,
                        zone_ids: this.filters.zones.map(t => t.id),
                        trading_area_ids: this.filters.trading_area.map(
                            t => t.id,
                        ),
                    },
                };

                await this.getStations(params);

                this.promotion.outlets = this.stationsPool.map(t => t.id);
            } else {
                this.setSelectedAll(false);
                this.promotion.outlets = [];
            }
        },
    },
};
</script>


<style>
.my-custom-scrollbar {
    position: relative;
    height: 200px;
    overflow: overlay;
}
.table-wrapper-scroll-y {
    display: compact;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/promotion/station_list.vue